import { parse as parseQs } from "qs";
import React from "react";
import { RouteComponentProps } from "react-router-dom";

import { HomeUrlQueryParams } from "./urls";
import HomeSection from "./views";

const Component = ({ location }: RouteComponentProps) => {
  const params: HomeUrlQueryParams = parseQs(location.search.substr(1));

  return <HomeSection params={params} />;
};

export default Component;
